import React from "react"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import Button from "@material-ui/core/Button"
import DoneIcon from "@material-ui/icons/Done"
import ErrorIcon from "@material-ui/icons/Error"
import CircularProgress from "@material-ui/core/CircularProgress"
import { Link } from "@material-ui/core"

const Four = ({ classes, error, success, message, tryAgain, goBack }) => {
    return (
        <div className={classes.bigContainer}>
            <Paper className={classes.paper}>
                <div
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div style={{ textAlign: "center" }}>
                        {
                            !message ?
                                <React.Fragment>
                                    <div style={{ marginBottom: 32 }}>
                                        <Typography
                                            variant="h6"
                                            style={{ fontWeight: "bold" }}
                                            gutterBottom
                                        >
                                            Estamos enviando sua Inscrição
              </Typography>
                                        <Typography variant="body1" gutterBottom>
                                            Por favor, aguarde
              </Typography>
                                    </div>
                                    <CircularProgress
                                        style={{
                                            marginBottom: 32,
                                            width: 100,
                                            height: 100
                                        }}
                                    />
                                </React.Fragment>
                                :
                                [
                                    error && (
                                        <React.Fragment key="10">
                                            <ErrorIcon
                                                width={100}
                                            />
                                            <Typography
                                                variant="h6"
                                                color="error"
                                            >
                                                {message}
                                            </Typography>
                                            <Button onClick={tryAgain}>
                                                Tentar novamente
                        </Button>
                                        </React.Fragment>
                                    ),
                                    success && (
                                        <React.Fragment key="10">
                                            < DoneIcon
                                                width={100}
                                            />
                                            <Typography
                                                variant="h6"
                                            >
                                                {message}
                                            </Typography>
                                            <Link component="button" onClick={goBack}>
                                                Voltar ao Início
                        </Link>
                                        </React.Fragment>
                                    )
                                ]
                        }
                    </div>
                </div>
            </Paper>
        </div>
    );
}

export default Four;